module.exports = "/templates/forgotpassword.html";


//////////////////
// WEBPACK FOOTER
// ./src/templates/forgotpassword.html
// module id = 448
// module chunks = 0